/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".file-download-link[_ngcontent-%COMP%]   .mat-spinner[_ngcontent-%COMP%]{display:inline}"];
export { styles as styles };
